/**
 * Uses two points, top and bottom, to create a
 * region where the element is active. Ensures
 * the element is not fixed over the `<footer>`,
 * for example.
 */

export default class ProductCTASticky {
    constructor(el) {
        this.el = el;
        this.activeRegionTop = document.querySelector('.js-pdp-cta-sticky-context-top');
        this.activeRegionBottom = document.querySelector('.js-pdp-cta-sticky-context-bottom');
        this.breakpoint = 1024;

        if (!el && !this.activeRegionTop && !this.activeRegionBottom) return;

        this.observer = null;
        this.scrollPos = null;
        this.init();
    }

    init () {
        const breakpointMq = window.matchMedia(`(min-width: ${this.breakpoint}px)`);

        breakpointMq.addEventListener('change', e => {
            if (e.matches) {
                this.initObserver();
            } else {
                if (this.observer != null) {
                    this.destroyObserver();
                }

                this.el.inert = false;
                this.el.setAttribute('aria-hidden', false);
            }
        });

        if (window.innerWidth >= this.breakpoint) {
            this.initObserver();
        } else {
            if (this.observer != null) {
                this.destroyObserver();
            }
        }
    }

    initObserver () {
        this.setElInvisible();

        this.observer = new IntersectionObserver((entries) => {
            // Checks if the window is short enough to not have both trigger points potentially visible at the same time, minus 100 pixels to ensure consistency in IntersectionObserver calculations.
            if (window.innerHeight - 100 < (Math.round(this.activeRegionBottom.getBoundingClientRect().top) - Math.round(this.activeRegionTop.getBoundingClientRect().bottom))) {
                entries.forEach(entry => {
                    if (entry.target === this.activeRegionTop && this.scrollPos !== null && entry.boundingClientRect.top <= 0 && window.scrollY > this.scrollPos) {
                        this.setElVisible();
                    } else if (entry.target === this.activeRegionTop && window.scrollY <= this.scrollPos) {
                        this.setElInvisible();
                    } else if (entry.target === this.activeRegionBottom && this.scrollPos !== null && window.scrollY <= this.scrollPos) {
                        this.setElVisible();
                    } else if (entry.target === this.activeRegionBottom && entry.isIntersecting) {
                        this.setElInvisible();
                    }
                });
            }
            this.scrollPos = window.scrollY;
        });

        this.observer.observe(this.activeRegionTop);
        this.observer.observe(this.activeRegionBottom);
    }

    destroyObserver () {
        this.observer.unobserve(this.activeRegionTop);
        this.observer.unobserve(this.activeRegionBottom);

        this.observer.disconnect();
        this.observer = null;
    }

    setElVisible () {
        this.el.inert = false;
        this.el.setAttribute('aria-hidden', false);
        this.el.classList.add('is-active');
    }

    setElInvisible () {
        this.el.inert = true;
        this.el.setAttribute('aria-hidden', true);
        this.el.classList.remove('is-active');
    }
}
